import lux from "@/assets/1742561569_3593189334595606656.webp";
import couple from "@/assets/1779847500_3905966368420069795.webp";
import pine from "@/assets/1779947897_3906808566430270185.webp";
import bust from "@/assets/1780018027_3907396849912522036.webp";

export const mockUser = {
  name: "Aarav Sharma",
  email: "aarav@royallumina.com",
  phone: "+91 98765 43210",
  memberSince: "March 2024",
  tier: "Gold Member",
};

export const mockOrders = [
  { id: "RL-2841", date: "12 Jun 2026", status: "Delivered", total: 2498, items: 3, img: couple },
  { id: "RL-2790", date: "28 May 2026", status: "Shipped", total: 1299, items: 1, img: lux },
  { id: "RL-2712", date: "14 May 2026", status: "Delivered", total: 899, items: 1, img: pine },
  { id: "RL-2655", date: "02 May 2026", status: "Cancelled", total: 649, items: 1, img: bust },
];

export const mockAddresses: Array<{
  id: string;
  label: string;
  name: string;
  line1: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  default: boolean;
}> = [];

export const mockCart = [
  { id: "1", name: "Rose Couple Candle", price: 899, qty: 1, img: couple, variant: "Rose · Medium" },
  { id: "6", name: "Luxury Gift Set", price: 1299, qty: 1, img: couple, variant: "Woody · Set of 3" },
  { id: "3", name: "Crystal Glow Votives", price: 799, qty: 2, img: lux, variant: "Gold · Trio" },
];
